import CryptoJS from "crypto-js";

/**
 * Encrypts data using AES with a secret key from the environment.
 *
 * @param {string} data - The data to encrypt.
 * @param {string} secretKey - The secret key for encryption.
 * @returns {string} - The encrypted data.
 */
export function encryptSessionData(data: string): string {
  const secretKey = process.env.NEXT_PUBLIC_SESSION_SECRET;
  if (!secretKey) {
    throw new Error("Encryption secret key is not defined.");
  }
  return CryptoJS.AES.encrypt(data, secretKey).toString();
}
